import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Breadcrumb } from '../shared/breadcrumb/breadcrumb';

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [RouterLink, Breadcrumb],
  templateUrl: './services.component.html',
  styleUrl: './services.component.css'
})
export class ServicesComponent {
  readonly services = [
    ['bi-window', 'Digital User Experience']
  ];
}
